export default {
	large: 600,
	small: 300,
}
